
import React from "react";

const ErrorPopup = ({ show, message, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="design-for-alerts">
        <img
          src="/alert-icon.svg"
          alt="Alert logo"
          className="alert-icon-design"
        />
        <h2 className="alerts-heading mt-2">Can’t Complete Request</h2>
        <p className="alerts-heading-response">{message}</p>
        <button onClick={onClose} className="alerts-button-okay">
          Okay
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;
